import React from 'react';
import classNames from 'classnames';
import './Input.scss';

interface InputProps {
  value: string;
  label: string;
  placeholder?: string;
  onChange?: any;
  block?: any;
  errors?: string;
  mask?: any;
  disabled?: any;
  onfocus?: any;
  messageInput?: any;
  maxLength?: any;
  required?: any;
}

const Input = ({
  block,
  errors,
  label,
  mask,
  onChange,
  placeholder,
  required,
  disabled,
  value,
  onfocus,
  messageInput,
  maxLength,
  ...rest
}: InputProps) => (
  <>
    <div
      className={classNames('input', {
        'input--errors': errors, 'input--filled': value && value.length > 0, 'input--block': block,
      })}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="reporting__heading" style={{ color: 'black' }}>
          {label}
        </div>
        {required && <div className="input__required" />}
      </div>
      <input
        type={mask ? 'password' : 'text'}
        className={messageInput ? 'input__control input__control1' : 'input__control'}
          onChange={onChange}
          disabled={disabled}
          onFocus={onfocus}
          value={value}
          maxLength={maxLength ? maxLength : null}
          required={required}
          placeholder={placeholder}
          {...rest}
        />
        <div className="input__underline" />
      </div>
      {maxLength ? (<div
          style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -15 }}
        >
          {value.length + '/' + maxLength}
        </div>) : null}
      {errors && (<div className="input__errors">
          {errors ? <div className="input__error">{errors}</div> : ''}
        </div>)}
    </>
    );

    Input.defaultProps = {value: '',};

    export default Input;
